// removed by extract-text-webpack-plugin
module.exports = {"Preferences":"Preferences--1WFjD","CardContent":"CardContent--2mzuZ","PrefItem":"PrefItem--1sfhA"};